import { render, staticRenderFns } from "./DatePickerField.vue?vue&type=template&id=f8bc6e4a&scoped=true"
import script from "./DatePickerField.vue?vue&type=script&lang=ts"
export * from "./DatePickerField.vue?vue&type=script&lang=ts"
import style0 from "./DatePickerField.vue?vue&type=style&index=0&id=f8bc6e4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8bc6e4a",
  null
  
)

export default component.exports